import isArray from 'lodash/isArray'
import { formatTime } from '@src/utils/moment.util.js'
export const afterDraw = (graphData, isdata) => {
  const { datasets } = graphData.value.data
  isdata.value = false

  for (let dataset of datasets) {
    if (dataset.data.length > 0 && dataset.data.some((item) => item !== 0)) {
      isdata.value = true
      break
    }
  }
}

export const getGradient = (ctx, chartArea, gradient, width, height) => {
  const chartWidth = chartArea.right - chartArea.left
  const chartHeight = chartArea.bottom - chartArea.top
  if (!gradient || width !== chartWidth || height !== chartHeight) {
    width = chartWidth
    height = chartHeight
    gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top)
    gradient.addColorStop(0, 'rgba(127, 86, 217, 0)')
    gradient.addColorStop(1, 'rgba(127, 86, 217, .2)')
  }
  return gradient
}

export const configureLegend = (options, chart) => {
  options.plugins.legend.labels.generateLabels = (chart) =>
    chart.data.datasets
      .map((ds, i) => ({
        text: ds.label,
        datasetIndex: i,
        fillStyle: chart.data.datasets[i].backgroundColor,
        strokeStyle: chart.data.datasets[i].backgroundColor,
        hidden: chart.getDatasetMeta(i).hidden,
      }))
      .filter((ds, i) => i % 3 == 0)

  options.plugins.legend.onClick = (event, legendItem, legend) => {
    let hidden = !legend.chart.getDatasetMeta(legendItem.datasetIndex).hidden

    if (legendItem.datasetIndex === 0) {
      ;[0, 1, 2].forEach((i) => (legend.chart.getDatasetMeta(i).hidden = hidden))
    } else if (legendItem.datasetIndex === 3) {
      ;[3, 4, 5].forEach((i) => (legend.chart.getDatasetMeta(i).hidden = hidden))
    } else if (legendItem.datasetIndex === 6) {
      ;[6, 7, 8].forEach((i) => (legend.chart.getDatasetMeta(i).hidden = hidden))
    }

    legend.chart.update()
  }
}

export const configureDatalabels = (options, startTimeInMinutes) => {
  options.plugins.datalabels.formatter = (value, ctx) => {
    if (value === 0) {
      return null
    }

    const presArray = ctx?.dataset?.pres
    const teacherArray = ctx?.dataset?.teacher
    const labelArray = ctx?.dataset?.label

    const pres = isArray(presArray) ? presArray[ctx.dataIndex] : null
    const teacher = isArray(teacherArray) ? teacherArray[ctx.dataIndex] : ''
    const label = isArray(labelArray) ? labelArray[ctx.dataIndex] || '' : ''

    const maxLength = 8
    const truncatedLabel = label.length > maxLength ? label.slice(0, maxLength - 2) + '…' : label
    const truncatedTeacher =
      teacher.length > maxLength ? teacher.slice(0, maxLength - 2) + '…' : teacher

    if (truncatedLabel === 'empty') return [truncatedLabel]
    else if (pres) return [truncatedLabel, `Pres: ${pres}`]
    else return [truncatedLabel, truncatedTeacher]
  }

  if (options.scales?.y?.ticks) {
    options.scales.y.ticks.callback = (value) => {
      return formatTime(value + startTimeInMinutes)
    }
  }
}

export const setDatasetFill = (datasets) => {
  datasets.forEach((dataset) => {
    if (dataset.fill) {
      dataset.fill.above = function (context) {
        const chart = context.chart
        const { ctx, chartArea } = chart
        if (!chartArea) {
          return null
        }
        return getGradient(ctx, chartArea)
      }
    }
  })
}
export const configureTooltip = (options, graphData) => {
  const { tooltipHeader, timetable } = graphData.value
  const afterTitle = graphData.value.afterTitle

  if (!options.plugins.tooltip) {
    options.plugins.tooltip = {}
  }
  if (!options.plugins.tooltip.callbacks) {
    options.plugins.tooltip.callbacks = {}
  }

  if (tooltipHeader) {
    options.plugins.tooltip.callbacks.title = function (tooltipItems) {
      if (!Array.isArray(tooltipItems) || tooltipItems.length === 0) {
        return ''
      }
      const titleIndex = tooltipItems[0]?.parsed?.x
      if (titleIndex !== null && titleIndex >= 0 && titleIndex < tooltipHeader.length) {
        return tooltipHeader[titleIndex]
      } else {
        return titleIndex
      }
    }

    if (timetable) {
      options.plugins.tooltip.callbacks.label = function (context) {
        const { dataset, dataIndex } = context
        const subject = dataset.label?.[dataIndex] || 'Unknown'
        const total = dataset.total?.[dataIndex] ?? 0
        const present = dataset.pres?.[dataIndex] ?? 0
        const absent = total - present
        const duration = dataset.data?.[dataIndex] ?? 0
        return [
          `Subject: ${subject}`,
          `Duration: ${duration} Minutes`,
          `Present: ${present}`,
          `Absent: ${absent}`,
        ]
      }
    }
  }

  if (afterTitle) {
    options.plugins.tooltip.callbacks.label = function (context) {
      if (!context.raw.exam) return
      const { dataset } = context
      const subject = dataset.label || 'Unknown'
      const marks = context.raw.y
      return `${subject}: ${Number.isInteger(marks) ? marks : marks.toFixed(2)}%`
    }
    options.plugins.tooltip.callbacks.afterTitle = function (context) {
      const subTitle = context[0]?.raw?.exam || afterTitle[context[0].datasetIndex]
      return subTitle || ''
    }
  }
}
